export function numberLocaleForLanguage(lang: string): string {
  if (lang.startsWith('sv')) return 'sv-SE';
  if (lang.startsWith('en')) return 'en-GB';
  return 'fi-FI';
}
